/** O telefone do passageiro (#6699) como a pessoa o lê: a máscara BR com DDI
 *  («+55 (11) 9 8765-4321»), progressiva enquanto digita. Um número que já vem
 *  com outro DDI («+1…») fica só com os dígitos. */

const BR_DDI = '55';
/** DDD + assinante: celular (9 + 8 dígitos) ou fixo (8 dígitos, sem 0/1). */
const BR_NATIONAL = /^[1-9]\d(?:9\d{8}|[2-8]\d{7})$/;
const E164 = /^\+[1-9]\d{6,14}$/;

/** Os dígitos nacionais do BR, ou `null` quando o número traz outro DDI. */
function brNational(typed: string): string | null {
  const digits = typed.replaceAll(/\D/g, '');
  const plus = typed.trim().startsWith('+');
  if (plus && !digits.startsWith(BR_DDI)) return null;
  const withDdi = digits.startsWith(BR_DDI) && (plus || digits.length > 11);
  return withDdi ? digits.slice(BR_DDI.length) : digits;
}

function subscriber(rest: string): string {
  if (rest.length === 9) return `${rest.slice(0, 1)} ${rest.slice(1, 5)}-${rest.slice(5)}`;
  return rest.length > 4 ? `${rest.slice(0, 4)}-${rest.slice(4)}` : rest;
}

export function maskPhone(typed: string): string {
  const national = brNational(typed);
  if (national === null) return `+${typed.replaceAll(/\D/g, '')}`;
  // «+5» → «+55»: o DDI digitado fica até chegarem os dígitos nacionais.
  if (!national) return typed.trim().startsWith('+') ? `+${typed.replaceAll(/\D/g, '')}` : '';
  const ddd = national.slice(0, 2);
  // Dígito a mais fica à vista (e reprova no `phoneE164`), em vez de sumir.
  const rest = national.slice(2, 11);
  const surplus = national.slice(11);
  return `+${BR_DDI} (${ddd}${rest ? `) ${subscriber(rest)}` : ''}${surplus}`;
}

/** O número em E.164 (`+5511987654321`) quando dá para ligar — com DDD no BR —,
 *  senão `null`. */
export function phoneE164(typed: string): string | null {
  const national = brNational(typed);
  if (national === null) {
    const e164 = `+${typed.replaceAll(/\D/g, '')}`;
    return E164.test(e164) ? e164 : null;
  }
  return BR_NATIONAL.test(national) ? `+${BR_DDI}${national}` : null;
}
